import { useTranslation } from 'react-i18next';
import type { SceneStore } from '@os/doc';
import { Dialog, ListItem } from '../../ui';
import { pageLabel } from './labels';

/** « Déplacer vers la page… » of the context menu (P14): every other page; the user stays on the current one. */
export function MoveToPageDialog({ store, ids, onClose }: { store: SceneStore; ids: readonly string[]; onClose: () => void }) {
  const { t } = useTranslation();
  const pages = store.pages();
  return (
    <Dialog title={t('pages.moveTitle')} description={t('pages.moveHint')} onClose={onClose}>
      <ul className="flex flex-col gap-1">
        {pages.map((p, i) =>
          p.id === store.page ? null : (
            <li key={p.id}>
              <ListItem
                label={pageLabel(t, p, i)}
                onClick={() => {
                  store.commands.moveToPage([...ids], p.id);
                  onClose();
                }}
              />
            </li>
          ),
        )}
      </ul>
    </Dialog>
  );
}
